import React from "react";

import { Route, Router, Switch } from "react-router-dom";
import { history } from "./history";

import * as Pages from "pages";
import { PermissionsEnum } from "common";

import { AuthRoute, PrivateRoute } from "./components";

const Routes = () => (
  <Router history={history}>
    <Switch>
      {/* <Route path="/" component={Pages.Dashboard} exact /> */}
      <Route path="/auth/sso" component={Pages.Auth.SingleSignOne} exact />
      <Route path="/login" component={Pages.Auth.Login} exact />
      <AuthRoute path="/home-login" component={Pages.Auth.HomeLogin} exact />
      <AuthRoute path="/register" component={Pages.Auth.Register} exact />
      <AuthRoute
        path="/recover-password"
        component={Pages.Auth.RecoverPassword}
        exact
      />

      {/* Require authentication to access */}
      <PrivateRoute path="/" component={Pages.Dashboard} exact />

      {/* Report */}
      <PrivateRoute
        path="/reports"
        component={Pages.Reports.Main}
        permissions={[
          "manage-report-ranking-points",
          "manage-report-ranking-registers",
          "manage-report-provisioned-vouchers",
          "manage-events-attendance",
          "manage-report-provisioned-points",
          "manage-report-average-tickets",
          "manage-report-points",
          "manage-report-benefits",
          "manage-report-accountant",
        ]}
        exact
      />
      <PrivateRoute
        path="/report/provision-points"
        component={Pages.Reports.ProvisionPoints}
        permissions="manage-report-provisioned-points"
        exact
      />
      <PrivateRoute
        path="/report/voucher-expense"
        component={Pages.Reports.VoucherExpense}
        permissions="manage-report-provisioned-vouchers"
        exact
      />
      <PrivateRoute
        path="/report/benefits"
        component={Pages.Reports.Benefits}
        permissions="manage-report-benefits"
        exact
      />
      <PrivateRoute
        path="/report/points"
        component={Pages.Reports.Points}
        permissions="manage-report-points"
        exact
      />
      <PrivateRoute
        path="/report/generals"
        component={Pages.Reports.Generals}
        permissions="manage-report-general"
        exact
      />
      <PrivateRoute
        path="/report/tickets"
        component={Pages.Reports.Tickets}
        permissions="manage-report-average-tickets"
        exact
      />
      <PrivateRoute
        path="/report/registers-ranking"
        component={Pages.Reports.RegistersRanking}
        permissions="manage-report-ranking-registers"
        exact
      />
      <PrivateRoute
        path="/report/points-ranking"
        component={Pages.Reports.PointsRanking}
        permissions="manage-report-ranking-points"
        exact
      />
      <PrivateRoute
        path="/report/webpremios"
        component={Pages.Reports.Webpremios}
        permissions="manage-report-webpremios"
        exact
      />
      <PrivateRoute
        path="/report/accountant"
        component={Pages.Reports.Accountant}
        permissions="manage-report-accountant"
        exact
      />

      {/* Accounting Validation */}
      <PrivateRoute
        path="/report/accounting-validation"
        component={Pages.Reports.AccountingValidation.Main}
        permissions="accounting-validation"
        exact
      />
      <PrivateRoute
        path="/report/accounting-validation/used"
        component={Pages.Reports.AccountingValidation.UsedVouchers}
        permissions="accounting-validation"
        exact
      />
      <PrivateRoute
        path="/report/accounting-validation/activated"
        component={Pages.Reports.AccountingValidation.ActivatedVouchers}
        permissions="accounting-validation"
        exact
      />

      {/* Professionals */}
      <PrivateRoute
        path="/professionals"
        component={Pages.Professionals.Main}
        permissions={["view-customer-presential", "manage-presencial-docs"]}
        exact
      />
      <PrivateRoute
        path="/professionals/customers"
        component={Pages.Professionals.Customers.List}
        permissions={["view-customer-presential"]}
        exact
      />
      <PrivateRoute
        path="/professionals/customers/create"
        component={Pages.Professionals.Customers.Create}
        permissions={["manage-customer-presential"]}
        exact
      />
      <PrivateRoute
        path="/professionals/documents"
        component={Pages.Professionals.Documents.List}
        permissions={["manage-presencial-docs"]}
        exact
      />
      <PrivateRoute
        path="/professionals/documents/:id/edit"
        component={Pages.Professionals.Documents.Edit}
        permissions={["manage-presencial-docs"]}
        exact
      />

      {/* Points Routers */}
      <PrivateRoute
        path="/points"
        component={Pages.Points.Main}
        permissions={[
          "manage-vouchers",
          "manage-channels",
          "manage-product-types",
          "manage-places",
          "manage-payment-methods",
        ]}
        exact
      />
      <PrivateRoute path="/points/terms" component={Pages.Points.Terms} exact />

      {/* Channels */}
      <PrivateRoute
        path="/points/channels"
        component={Pages.Points.Channels.List}
        permissions="manage-channels"
        exact
      />
      <PrivateRoute
        path="/points/channels/:id/edit"
        component={Pages.Points.Channels.Edit}
        permissions="edit-channels"
        exact
      />

      {/* Vouchers */}
      <PrivateRoute
        path="/points/vouchers"
        component={Pages.Points.Vouchers.List}
        permissions="manage-vouchers"
        exact
      />
      <PrivateRoute
        path="/points/vouchers/create"
        component={Pages.Points.Vouchers.Create}
        permission="edit-vouchers"
        exact
      />
      <PrivateRoute
        path="/points/vouchers/:id/edit"
        component={Pages.Points.Vouchers.Edit}
        permission="edit-vouchers"
        exact
      />

      {/* Stores */}
      <PrivateRoute
        path="/points/stores"
        component={Pages.Points.Stores.List}
        permissions="manage-places"
        exact
      />
      <PrivateRoute
        path="/points/stores/:id/edit"
        component={Pages.Points.Stores.Edit}
        permissions="edit-places"
        exact
      />

      {/* Payments */}
      <PrivateRoute
        path="/points/payments"
        component={Pages.Points.Payments.List}
        permissions="manage-payment-methods"
        exact
      />
      <PrivateRoute
        path="/points/payments/create"
        component={Pages.Points.Payments.Create}
        permissions="edit-payment-methods"
        exact
      />
      <PrivateRoute
        path="/points/payments/:id/edit"
        component={Pages.Points.Payments.Edit}
        permissions="edit-payment-methods"
        exact
      />

      {/* Product Types */}
      <PrivateRoute
        path="/points/products-types"
        component={Pages.Points.ProductsTypes.List}
        permissions="manage-product-types"
        exact
      />
      <PrivateRoute
        path="/points/products-types/:id/edit"
        component={Pages.Points.ProductsTypes.Edit}
        permissions="edit-product-types"
        exact
      />

      {/* Campaign */}
      <PrivateRoute
        path="/points/campaigns"
        component={Pages.Points.Campaign.List}
        permissions="manage-campaigns"
        exact
      />
      <PrivateRoute
        path="/points/campaigns/create"
        component={Pages.Points.Campaign.Create}
        permissions="edit-campaigns"
        exact
      />
      <PrivateRoute
        path="/points/campaigns/:id/edit"
        component={Pages.Points.Campaign.Edit}
        permissions="edit-campaign"
        exact
      />

      {/* Prize */}
      <PrivateRoute
        path="/points/prizes"
        component={Pages.Points.Prize.List}
        permissions="manage-prizes"
        exact
      />
      <PrivateRoute
        path="/points/prizes/create"
        component={Pages.Points.Prize.Create}
        permissions="edit-prizes"
        exact
      />
      <PrivateRoute
        path="/points/prizes/:id/edit"
        component={Pages.Points.Prize.Edit}
        permissions="edit-prizes"
        exact
      />

      {/* Multipler */}
      <PrivateRoute
        path="/points/multiplier"
        component={Pages.Points.Multipliers.List}
        permissions="manage-multiplier"
        exact
      />
      <PrivateRoute
        path="/points/multiplier/create"
        component={Pages.Points.Multipliers.Create}
        permissions="edit-multiplier"
        exact
      />
      <PrivateRoute
        path="/points/clone"
        component={Pages.Points.Clone}
        permissions="edit-multiplier"
        exact
      />
      <PrivateRoute
        path="/points/multiplier/:id/edit"
        component={Pages.Points.Multipliers.Edit}
        permissions="edit-multiplier"
        exact
      />

      {/* Multipler */}
      <PrivateRoute
        path="/points/cpf-list"
        component={Pages.Points.CPFList.List}
        permissions="manage-points-assigner"
        exact
      />
      <PrivateRoute
        path="/points/cpf-list/create"
        component={Pages.Points.CPFList.Create}
        permissions="manage-points-assigner"
        exact
      />
      <PrivateRoute
        path="/points/cpf-list/:id/show"
        component={Pages.Points.CPFList.Show}
        permissions="manage-points-assigner"
        exact
      />

      {/* Benefits Routers */}
      <PrivateRoute
        path="/benefits"
        component={Pages.Benefits.Main}
        permissions="manage-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/list"
        component={Pages.Benefits.List}
        permissions="manage-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/create"
        component={Pages.Benefits.Create}
        permissions="edit-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/clone"
        component={Pages.Benefits.Clone}
        permissions="edit-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/:id/edit"
        component={Pages.Benefits.Edit}
        permissions="edit-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/types/list"
        component={Pages.Benefits.Types.List}
        permissions="manage-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/types/create"
        component={Pages.Benefits.Types.Create}
        permissions="edit-benefits"
        exact
      />

      <PrivateRoute
        path="/benefits/types/:id/edit"
        component={Pages.Benefits.Types.Edit}
        permissions="edit-benefits"
        exact
      />

      {/* Campaign */}
      <PrivateRoute
        path="/benefits/campaign/list"
        component={Pages.Benefits.Campaign.List}
        permissions="manage-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/campaign/create"
        component={Pages.Benefits.Campaign.Create}
        permissions="edit-benefits"
        exact
      />
      <PrivateRoute
        path="/benefits/campaign/:id/edit"
        component={Pages.Benefits.Campaign.Edit}
        permissions="edit-benefits"
        exact
      />

      {/* Events Routers */}
      <PrivateRoute
        path="/events"
        component={Pages.Events.Main}
        permissions="manage-events"
        exact
      />
      <PrivateRoute
        path="/events/list"
        component={Pages.Events.List}
        permissions="manage-events"
        exact
      />
      <PrivateRoute
        path="/events/create"
        component={Pages.Events.Create}
        permissions="edit-events"
        exact
      />
      <PrivateRoute
        path="/events/:id/edit"
        component={Pages.Events.Edit}
        permissions="edit-events"
        exact
      />

      {/* Invites Routers and List Presence*/}
      <PrivateRoute
        path="/events/:id/invite"
        component={Pages.Events.Invite}
        permissions="manage-events-invites"
        exact
      />
      <PrivateRoute
        path="/events/:id/attendances"
        component={Pages.Events.Attendances}
        permissions="manage-events-attendance"
        exact
      />

      {/* Configs */}
      <PrivateRoute
        path="/configs"
        component={Pages.Configs.Main}
        permissions={[
          "edit-messages",
          "edit-users",
          "edit-access-groups",
          "edit-permissions",
          "edit-variables",
          "edit-log",
          "edit-incidents",
        ]}
        exact
      />
      <PrivateRoute
        path="/configs/messages"
        component={Pages.Configs.Messages}
        permissions="edit-messages"
        exact
      />
      <PrivateRoute
        path="/configs/log"
        component={Pages.Configs.Log}
        permissions="edit-log"
        exact
      />
      <PrivateRoute
        path="/configs/incidents"
        component={Pages.Configs.Incidents}
        permissions="edit-incidents"
        exact
      />
      <PrivateRoute
        path="/configs/users"
        component={Pages.Configs.Users.List}
        permissions="edit-users"
        exact
      />
      <PrivateRoute
        path="/configs/users/:id/edit"
        component={Pages.Configs.Users.Edit}
        permissions="edit-users"
        exact
      />
      <PrivateRoute
        path="/configs/groups"
        component={Pages.Configs.Groups.List}
        permissions="edit-access-groups"
        exact
      />
      <PrivateRoute
        path="/configs/groups/create"
        component={Pages.Configs.Groups.Create}
        permissions="edit-access-groups"
        exact
      />
      <PrivateRoute
        path="/configs/groups/:id/edit"
        component={Pages.Configs.Groups.Edit}
        permissions="edit-access-groups"
        exact
      />
      <PrivateRoute
        path="/configs/roles"
        component={Pages.Configs.Roles.List}
        permissions="edit-permissions"
        exact
      />
      <PrivateRoute
        path="/configs/roles/create"
        component={Pages.Configs.Roles.Create}
        permissions="edit-permissions"
        exact
      />
      <PrivateRoute
        path="/configs/roles/:id/edit"
        component={Pages.Configs.Roles.Edit}
        permissions="edit-permissions"
        exact
      />
      <PrivateRoute
        path="/configs/settings"
        component={Pages.Configs.Settings.List}
        permissions="edit-variables"
        exact
      />
      <PrivateRoute
        path="/configs/settings/:id/edit"
        component={Pages.Configs.Settings.Edit}
        permissions="edit-variables"
        exact
      />

      {/* Documents */}
      <PrivateRoute path="/documents" component={Pages.Documents.Main} exact />
      <PrivateRoute
        path="/documents/list"
        component={Pages.Documents.List}
        permissions="manage-documents"
        exact
      />
      <PrivateRoute
        path="/documents/:id/edit"
        component={Pages.Documents.Edit}
        permissions="edit-documents"
        exact
      />

      {/* Reasons */}
      <PrivateRoute path="/reasons/list" component={Pages.Reasons.List} exact />
      <PrivateRoute
        path="/reasons/create"
        component={Pages.Reasons.Create}
        permissions="manage-documents"
        exact
      />
      <PrivateRoute
        path="/reasons/:id/edit"
        component={Pages.Reasons.Edit}
        permissions="edit-documents"
        exact
      />

      {/* Regions */}
      <PrivateRoute
        path="/regions"
        component={Pages.Regions.List}
        permissions="manage-regions"
        exact
      />
      <PrivateRoute
        path="/regions/create"
        component={Pages.Regions.Create}
        permissions="edit-regions"
        exact
      />
      <PrivateRoute
        path="/regions/:id/edit"
        component={Pages.Regions.Edit}
        permissions="edit-regions"
        exact
      />

      {/* Extraction */}
      <PrivateRoute
        path="/extraction"
        component={Pages.Extraction.Main}
        permissions="manage-extraction"
        exact
      />
      <PrivateRoute
        path="/extraction/inhabitant"
        component={Pages.Extraction.Inhabitant}
        permissions="manage-extraction"
        exact
      />
      <PrivateRoute
        path="/extraction/vouchers"
        component={Pages.Extraction.AbandonedVouchers}
        permissions="manage-abandoned-vouchers"
        exact
      />

      <PrivateRoute
        path="/pro"
        component={Pages.Pro.Main}
        permissions={[
          "manage-inhabitant-segments",
          "view-inhabitant-segments",
          "view-cashback-imports",
          "manage-cashback-imports",
        ]}
        exact
      />

      <PrivateRoute
        path="/pro/create"
        component={Pages.Pro.Create}
        permissions={["manage-inhabitant-segments", "view-inhabitant-segments"]}
        exact
      />

      <PrivateRoute
        path="/pro/list"
        component={Pages.Pro.List}
        permissions={["manage-inhabitant-segments", "view-inhabitant-segments"]}
        exact
      />

      <PrivateRoute
        path="/pro/cashback/list"
        component={Pages.Pro.Cashback.List}
        permissions={["view-cashback-imports", "manage-cashback-imports"]}
        exact
      />

      <PrivateRoute
        path="/pro/cashback/automatic/list"
        component={Pages.Pro.Cashback.CashbackAutomatic}
        permissions={["view-cashback-imports", "manage-cashback-imports"]}
        exact
      />

      <PrivateRoute
        path="/pro/cashback/create"
        component={Pages.Pro.Cashback.CreateCashback}
        permissions={["view-cashback-imports", "manage-cashback-imports"]}
        exact
      />

      <PrivateRoute
        path="/external-cashback-campaigns/list"
        component={Pages.ExternalCashbackCampaigns.List}
        permissions={[
          PermissionsEnum.VIEW_EXTERNAL_CASHBACK_CAMPAIGN,
          PermissionsEnum.EDIT_EXTERNAL_CASHBACK_CAMPAIGN,
        ]}
        exact
      />

      <PrivateRoute
        path="/external-cashback-campaigns/create"
        component={Pages.ExternalCashbackCampaigns.Create}
        permissions={[
          PermissionsEnum.EDIT_EXTERNAL_CASHBACK_CAMPAIGN,
        ]}
        exact
      />

      <PrivateRoute
        path="/external-cashback-campaigns/:id/edit"
        component={Pages.ExternalCashbackCampaigns.Edit}
        permissions={[
          PermissionsEnum.EDIT_EXTERNAL_CASHBACK_CAMPAIGN,
        ]}
        exact
      />

      <PrivateRoute
        path="/processes/list"
        component={Pages.Processes.List}
        exact
      />

      <PrivateRoute
        path="/processes/:id/show"
        component={Pages.Processes.Show}
        exact
      />

      <PrivateRoute
        path="/pro/transfer-wallet"
        component={Pages.Pro.TransferWallet}
        permissions={[
          PermissionsEnum.MANAGE_CASHBACK_IMPORTS,
        ]}
        exact
      />

      <Route component={Pages.Errors.NotFound} />
    </Switch>
  </Router>
);

export default Routes;
